import React, { useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet";
import * as Yup from "yup";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../components/Button";
import ConfirmDialog from "../components/ConfirmDialog";

import "../assets/languages/i18n";
import {
  Box,
  Grid,
  Paper,
  TextField,
  Toolbar,
  Typography,
  InputAdornment,
  Alert,
} from "@mui/material";
import { Formik } from "formik";
import LoginBG from "../../src/assets/images/bg.svg";
import LoginLogo1 from "../../src/assets/images/login/design-stats-pana-1.svg";
import UnderConLogo from "../../src/assets/images/login/under-construction.png";
import CloseIcon from "../../src/assets/images/closeLogin.svg";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { makeStyles } from "@mui/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import * as Util from "../services/global.service";
import AuthService from "../services/auth.service";
import { login } from "../actions/auth";
import { logout } from "../actions/auth";
import {
  fetchStartParam,
  getSsoLogin,
  verifyRecaptcha,
} from "../actions/start";

import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const styles = {
  toolBar: {
    paddingLeft: "5px",
  },
  childToolBar: {
    padding: "32px 20px",
    fontWeight: "400",
  },
  title: {
    paddingBottom: "15px",
  },
  subTitle: {
    color: "#282C40 !important",
  },
};

const useStyles = makeStyles({
  error: {
    "& div > p": {
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
    },
    "& div > input": {
      fontSize: "14px",
      lineHeight: "15.4px",
    },
    "& div > label": {
      color: "#404349",
      fontSize: "18px",
      lineHeight: "19.8px",
      fontWeight: "500"
    },
  },
  "& > p": {
    color: " #CC6058 !important",
    fontSize: "14px",
    lineHeight: "15.4px",
    marginLeft: 0,
  },
  "& div > input": {
    fontSize: "14px",
    lineHeight: "15.4px",
  },
  "& div > label": {
    color: "#0C2B34 !important",
    fontSize: "16px",
    lineHeight: "17.6px",
    fontWeight: "500",
  },
  expire: {
    paddingRight: "20px",
  },
  cssLabel: {
    // color: "#0C2B34 !important"
  }
});

const LoginView = () => {
  // getData();
  const [cookies, setCookie] = useCookies(['member']);
  const classes = useStyles()
  const navigate = useNavigate();
  const { t, i18n } = useTranslation()
  let { site } = useParams()
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth);
  const Start = useSelector((state) => state.Start);
  const { executeRecaptcha } = useGoogleReCaptcha();
  let language = localStorage.getItem("lang");
  const [showPassword, setShowPassword] = useState(false);
  const [checkExpire, setCheckExpire] = useState(false);
  const [checkDup, setCheckDup] = useState();
  const [Texts, setText] = useState("");
  const [loginState, setLoginState] = useState(false);
  const [expireAlert, setExpireAlert] = useState(true);
  const [userLocked, setUserLocked] = useState(false);
  const [haveForgetPassword, setHaveForgetPassword] = useState(false);
  const [isDirectLogin, setIsDirectLogin] = useState(false);
  // Start?.data?.configuration?.username === 'emails'
  //const vForgetPassword = '/forget'//Start?.data?.configuration?.forget_password ? JSON.parse(Start.data.configuration.forget_password).value : "";
  const vForgetPassword = '/reset-password'
  const [errorUser, setErrorUser] = React.useState('')
  useEffect(() => {
    const channel = searchParams.get('channel')
    const isLoginDirect = (channel && channel === 'direct')
    setIsDirectLogin(isLoginDirect)

    if (site !== "" && site) {
      let getSiteCheck = localStorage.getItem("site")
      if (site !== getSiteCheck) {
        localStorage.setItem("site", site)
        dispatch(logout()).then(
          (response) => {
            window.location.href = '/' + site
            localStorage.removeItem("user");
            localStorage.removeItem("date");
            localStorage.removeItem("proxy");
          }
        ).catch((err) => {
          localStorage.removeItem('date');
          localStorage.removeItem('user');
          localStorage.removeItem("proxy");
          window.location.href = '/' + site
        })
      }
      localStorage.setItem("site", site)
    }
    document.getElementById('signin').style.display = "none"
    i18n.changeLanguage('en-US')
    var getSite = localStorage.getItem("site")
    dispatch(fetchStartParam(getSite ? getSite : "iamconsulting", isLoginDirect)).then((resp) => {
      localStorage.removeItem("API_URL");
      localStorage.removeItem('expireDate');

      if (resp?.data?.configuration?.language_default !== undefined && resp?.data?.configuration?.language_default !== null && resp?.data?.configuration?.language_default !== "") {

        //console.log('Language Default', resp.data.configuration.language_default)
        //if (language === undefined || language === null || language === "") {
        if (resp.data.configuration.language_default === 'en') {
          i18n.changeLanguage('en-US')
          localStorage.setItem("lang", 'en-US');
        } else if (resp.data.configuration.language_default === 'th') {
          i18n.changeLanguage('th-TH')
          localStorage.setItem("lang", 'th-TH');
        }
        //}
      }

      if (resp?.data?.auth_type && resp?.data?.auth_type === 'oauth') {

        if (resp.data.configuration?.maintenance || isLoginDirect) {
        }
        else {
          handleSsoLogin()
        }

        // 
      }
      else {
        if (user?.isLoggedIn === true) {
          if (user?.user?.reset_password === true) {
            navigate('/reset-new-password', { replace: false })
          } else if (user?.user?.change_password === true) {
            navigate('/set-new-password', { replace: false })
          } else if (user?.user?.consent === true) {
            navigate('/kpi/home', { replace: false })
          } else {
            navigate('/consent', { replace: false })
          }
        }
        if (resp?.data?.configuration?.forget_password) setHaveForgetPassword(true);
      }

      if (resp.data.configuration) {

        if (resp.data.configuration.api_url) {
          localStorage.setItem("API_URL", resp.data.configuration.api_url)
        }
      }

      if (resp?.custom?.language) {
        localStorage.setItem('custom_language', JSON.stringify(resp?.custom?.language))
        for (const lang of resp?.custom?.language) {
          let key = lang.code.split('.')
          let ns = 'translation'// key.shift()

          if (ns && key.length > 0) {
            let this_lang = (lang.language === 'th') ? 'th-TH' : 'en-US'
            i18n.addResource(this_lang, ns, key.join('.'), lang.value + '')
          }
        }
      }

    })
    handleCheck()
  }, [])

  // recaptcha
  const handleCaptchaAndFormSubmit = async (
    values,
    { setSubmitting, setErrors, setStatus, resetForm }
  ) => {
    onFormSubmit(values, {
      setSubmitting,
      setErrors,
      setStatus,
      resetForm,
    })
    return;

    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      alert("Couldn't load Recaptcha configuration")
      return;
    }

    const token = await executeRecaptcha("login");
    if (token) {
      dispatch(verifyRecaptcha(token)).then((resp) => {
        let result = resp.data.data;
        if (result.success) {
          if (result.score >= 0.5) {
            onFormSubmit(values, {
              setSubmitting,
              setErrors,
              setStatus,
              resetForm,
            });
          }
        } else {
          console.warn("recaptcha failed!");
        }
      })
    }
    return;
  };

  const onFormSubmit = (
    values,
    { setSubmitting, setErrors, setStatus, resetForm }
  ) => {

    localStorage.removeItem('expireDate');

    loginState
      ? dispatch(login(values.username, values.password, isDirectLogin)).then(
        (response) => {

          if (response?.user?.data?.data?.language) {
            language = (response?.user?.data?.data?.language === 'en') ? 'en-US' : 'th-TH'
            localStorage.setItem('lang', language)
            i18n.changeLanguage(language)
          }

          if (response?.user?.data?.data?.reset_password === true) {
            if (language != null) {
              i18n.changeLanguage(language)
            }
            navigate("/reset-new-password", { replace: false });
          } else if (response?.user?.data?.data?.change_password === true) {
            if (language != null) {
              i18n.changeLanguage(language)
            }
            navigate("/set-new-password", { replace: false });
          } else if (response?.user?.data?.data?.consent === true) {
            if (language != null) {
              i18n.changeLanguage(language)
            }
            navigate("/kpi/home", { replace: false });
          } else {
            if (language != null) {
              i18n.changeLanguage(language)
            }
            navigate("/consent", { replace: false });
          }
        },
        (response) => {
          setStatus({ success: false });
          setSubmitting(false);

          // const vErrorUser = "login.msg.user_not_found_in_pms"
          // const vErrorPass = "login.msg.cannot_login_ad"

          const vErrorUser = "user.msg.user_not_found";
          const vErrorPass = "login.msg.wrongpassword";
          const vErrorUserLock = "user.msg.user_locked"

          if (response?.data?.code === vErrorUser) {
            setErrors({
              username: t("login.msg.user_not_found_in_pms"),
            });
          }
          if (response?.data?.code === vErrorPass) {
            setErrors({
              password: t("login.msg.cannot_login_ad"),
            });
          }
          if (response?.data?.code === vErrorUserLock) {
            setUserLocked(true)
            setText(t('login.msg.user_locked'));
          }
        }
      )
      : // setSubmitting(false)
      // setLoginState(true)
      // AuthService for username
      AuthService.loginUser(values.username).then(
        (response) => {
          resetForm({
            values: {
              username: values.username,
              password: ''
            }
          })

          setLoginState(true);
          setSubmitting(false);
          localStorage.setItem("LOG_IN", "true");
        },
        (response) => {
          setStatus({ success: false });
          setSubmitting(false);
          const vErrorUser = "user.msg.user_not_found";
          const vErrorUserLock = "user.msg.user_locked"

          if (response?.data?.code === vErrorUser) {
            setErrors({
              username: t("login.msg.user_not_found_in_pms"),
            });
          }
          if (response?.data?.code === vErrorUserLock) {
            setUserLocked(true)
            setText(t('login.msg.user_locked'));
          }
        }
      );
  };


  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClick = () => {
    setShowPassword((prev) => !prev);
  };
  const handleClose = () => {
    setCheckExpire(false);
    setCheckDup("");
  };

  const handleCheck = () => {
    let checkDate = localStorage.getItem("expireDate");
    if (checkDate !== undefined && checkDate !== null) {
      setCheckExpire(checkDate);
      localStorage.removeItem("expireDate");
      localStorage.removeItem("error");
      setText(t('forgotpwd.msg.sessionTimeout'));
    }
    let error = JSON.parse(localStorage.getItem('error'))
    if (error?.error !== undefined && error?.error !== null) {
      if (error?.error === 401 || error?.error === "401") {
        if (error?.message !== undefined && error?.message !== null) {
          if (error?.message?.code === "token.msg.access_denied" || error?.message?.code === "Token not found" || error?.message === "token.msg.access_denied" || error?.message === "Token not found") {
            setCheckDup(error?.error)
            localStorage.removeItem("error");
            localStorage.removeItem("expireDate");
            setText(t('forgotpwd.msg.loginTimeout'));
          }
        }
      }
    }
  }

  // const handleCheck = () => {
  //   let checkDate = localStorage.getItem('expireDate')
  //   if (checkDate !== undefined && checkDate !== null) {
  //       setCheckExpire(checkDate)
  //       localStorage.removeItem('expireDate')
  //       localStorage.removeItem('error')
  //       setText(t('forgotpwd.msg.sessionTimeout'))
  //     }
  //     let error = JSON.parse(localStorage.getItem('error'))
  //     if (error?.error !== undefined && error?.error !== null) {
  //       if (error?.error === 401 || error?.error === "401") {
  //         if (error?.message !== undefined && error?.message !== null) {
  //           if (error?.message?.code === "token.msg.access_denied") {
  //             setCheckDup(error?.error)
  //             localStorage.removeItem('error')
  //             localStorage.removeItem('expireDate')
  //                   setText(t('forgotpwd.msg.loginTimeout'))
  //               }
  //           }
  //       }
  //   }
  // }
  const [isSsoDialogOpen, handleSsoDialog] = React.useState(false);

  const handleConfirmOpenSso = () => {
    handleSsoDialog(false);
    dispatch(getSsoLogin()).then((resp) => {
      if (resp.success) {
        if (resp.data !== "") window.location.href = resp.data;
      }
    });
  };

  const handleSsoLogin = () => {
    handleSsoDialog(true);
    handleConfirmOpenSso();
  };

  /*** control logic  */
  return (
    <>
      <Helmet>
        <title>Login | PMS</title>
      </Helmet>
      {/*<Box height={1} sx={{}}>*/}
      <Grid
        container
        sx={{
          height: "100%",
          minHeight: "600px",
          backgroundImage: `url(${LoginBG})`,
          backgroundSize: "cover",
        }}
      >
        <Grid
          container
          item
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: "center",
            overflow: "hidden",
            boxShadow: 0,
            fontWeight: "bold",
          }}
        >
          <Grid
            container
            item
            xs={12}
            lg={6}
            justifyContent="center"
            sx={{ display: { sm: "none", lg: "flex" } }}
            alignItems="center"
          >
            <img src={LoginLogo1} style={{ maxHeight: "485px" }} alt="IPOP PMS" />
          </Grid>
          <Grid container item xs={12} lg={6} spacing={4} sx={{}}>
            {checkExpire || checkDup === 401 || checkDup === "401" || userLocked ? (
              <Grid container item>
                <Grid item sx={{ maxWidth: "477px", width: "100%", }}>
                  <Alert
                    icon={false}
                    sx={{
                      color: "#CC6058",
                      background: "#FFE9E8",
                      borderRadius: "5px",
                      position: "relative",
                      "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1)",
                      ".MuiAlert-message": {
                        textAlign: userLocked ? "center" : "left",
                        width: "100%"
                      }
                    }}
                  >
                    <Typography
                      fontSize={14}
                      lineHeight="19.12px"
                      fontWeight={500}
                      // classes={{ root: classes.expire }}
                      sx={{ paddingRight: userLocked ? "0px" : "20px" }}
                    >
                      {Texts}
                    </Typography>
                    {userLocked === false ?
                      <Box
                        sx={{
                          position: "absolute",
                          right: 0,
                          margin: "15px 20px 0  0",
                          top: 0,
                        }}
                        onClick={handleClose}
                        className="clickable"
                      >
                        <img src={CloseIcon} alt="browser" />
                      </Box>
                      : null
                    }
                  </Alert>
                </Grid>
              </Grid>
            ) : null}
            <Grid
              direction="column"
              sx={{}}
              container
              item
              justifyContent="center"
              alignItems="center"
            >
              {Start?.data?.configuration?.maintenance ? (
                <Grid container item>
                  <Grid container item sx={{}}>
                    <Paper elevation={6} sx={{ padding: "50px" }}>
                      <img src={UnderConLogo} />
                      <Typography variant="h2" align="center">
                        {t("login.msg.underconMsg1")}
                      </Typography>
                      <br />
                      <Typography align="center" variant="h3">
                        {t("login.msg.underconMsg2")}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              ) : (
                <Grid container item sx={{}}>
                  {Start?.data?.client?.code &&

                    <Paper
                      elevation={6}
                      sx={{
                        padding: "50px",
                        "border-radius": "20px",
                        width: "100%",
                        maxWidth: "480px",
                        minHeight: "485px",
                        ".MuiFormHelperText-root": {
                          color: "#CC6058 !important",
                        }
                      }}
                      classes={{ root: classes.error }}
                    >

                      <>
                        {(Start?.data?.auth_type !== "oauth" || isDirectLogin) ? (
                          <Formik
                            // initialValues={{
                            //     username: 'chorchujai.san@nida.ac.th',
                            //     password: 'Chorchujai00'
                            // }}

                            initialValues={{
                              username: "",
                              password: "",
                            }}
                            validationSchema={Yup.object().shape(
                              Start?.data?.configuration?.username === "emails"
                                ? loginState
                                  ? {
                                    username: Yup.string()
                                      .email(t("login.msg.wrongusername"))
                                      .required(t("login.msg.specify_username")),
                                    password: Yup.string()
                                      .max(255)
                                      .required(t("login.msg.specify_password")),
                                  }
                                  : {
                                    username: Yup.string()
                                      .email(t("login.msg.wrongusername"))
                                      .required(t("login.msg.specify_username")),
                                  }
                                : loginState
                                  ? {
                                    username: Yup.string().required(
                                      t("login.msg.specify_username")
                                    ),
                                    password: Yup.string().required(
                                      t("login.msg.specify_password")
                                    ),
                                  }
                                  : {
                                    username: Yup.string().required(
                                      t("login.msg.specify_username")
                                    ),
                                  }
                            )}
                            onSubmit={(
                              values,
                              { setSubmitting, setErrors, setStatus, resetForm }
                            ) => {
                              handleCaptchaAndFormSubmit(values, {
                                setSubmitting,
                                setErrors,
                                setStatus,
                                resetForm,
                              });
                            }}
                          >
                            {({
                              errors,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                              isSubmitting,
                              touched,
                              values,
                            }) => (
                              <form
                                onSubmit={handleSubmit}
                                sx={{
                                  "& .MuiTextField-root": { m: 1, width: "25ch" },
                                }}
                              >
                                <Box sx={{ mb: 3 }}>
                                  <Typography
                                    color="primary"
                                    variant="h2"
                                    style={styles.title}
                                    fontSize={36}
                                    lineHeight="39.6px"
                                  >
                                    {t("login.label.signin")}
                                    {/* {t('login.label.signin')} : {site.toUpperCase()} */}
                                  </Typography>
                                  <Typography
                                    gutterBottom
                                    style={{ color: "black" }}
                                    fontSize={16}
                                    lineHeight="17.6px"
                                  >
                                    {t("login.label.signinDesc")}
                                  </Typography>
                                </Box>


                                {Start?.data?.configuration?.username ===
                                  "email" ? (
                                  <Box sx={{ ".MuiFormControl-root": { m: "0px" } }}>
                                    <Typography variant="subtitle1" fontSize={18} lineHeight="19.8px" color="#404349">{t("login.label.email")}</Typography>
                                    <TextField
                                      error={Boolean(
                                        touched.username && errors.username
                                      )}
                                      fullWidth
                                      helperText={touched.username && errors.username}
                                      margin="normal"
                                      name="username"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      type="email"
                                      value={values.username}
                                      variant="standard"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key == 'Enter') {
                                          e.preventDefault()
                                          handleSubmit()
                                        }
                                      }}
                                      placeholder={t("login.label.holderUsername")}
                                      disabled={loginState}
                                    />
                                  </Box>
                                ) : (
                                  <Box sx={{ ".MuiFormControl-root": { m: "0px" } }}>
                                    <Typography variant="subtitle1" fontSize={18} lineHeight="19.8px" color="#404349">{t("login.label.username")}</Typography>
                                    <TextField
                                      error={Boolean(
                                        touched.username && errors.username
                                      )}
                                      fullWidth
                                      helperText={touched.username && errors.username}
                                      margin="normal"
                                      name="username"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      type="text"
                                      value={values.username}
                                      variant="standard"
                                      InputLabelProps={{
                                        shrink: true,
                                        classes: {
                                          error: classes.cssLabel
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key == 'Enter') {
                                          e.preventDefault()
                                          handleSubmit()
                                        }
                                      }}
                                      placeholder={t("login.label.holderUsername")}
                                      disabled={loginState}
                                    />
                                  </Box>
                                )}
                                {loginState && (
                                  <Box sx={{ ".MuiFormControl-root": { m: "0px" } }}>
                                    <Typography mt="30px" variant="subtitle1" fontSize={18} lineHeight="19.8px" color="#404349">{t("login.label.password")}</Typography>
                                    <TextField
                                      error={Boolean(
                                        touched.password && errors.password
                                      )}
                                      autoFocus
                                      fullWidth
                                      helperText={touched.password && errors.password}
                                      margin="normal"
                                      name="password"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      // type="password"
                                      value={values.password}
                                      variant="standard"
                                      InputLabelProps={{
                                        shrink: true,
                                        classes: {
                                          error: classes.cssLabel
                                        }
                                      }}
                                      placeholder={t("login.label.holderPassword")}
                                      type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                                      onKeyDown={(e) => {
                                        if (e.key == 'Enter') {
                                          e.preventDefault()
                                          handleSubmit()
                                        }
                                      }}
                                      InputProps={{
                                        // <-- This is where the toggle button is added.
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <IconButton
                                              aria-label="toggle password visibility"
                                              onClick={handleClickShowPassword}
                                              onMouseDown={handleMouseDownPassword}
                                            >
                                              {showPassword ? (
                                                <Visibility />
                                              ) : (
                                                <VisibilityOff />
                                              )}
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </Box>
                                )}

                                <Grid
                                  container
                                  direction={"row"}
                                  sx={{ justifyContent: "flex-end" }}
                                >
                                  {haveForgetPassword ? (
                                    <Grid item pb={2} pt={2}>
                                      <Typography fontSize={14} lineHeight={1.1} color="#5DA196" sx={{ textDecoration: "underline", cursor: "pointer" }} onClick={e => navigate('/reset-password', { replace: false })}>
                                        {t("login.label.forgotPassword")}
                                      </Typography>
                                    </Grid>
                                  ) : (
                                    <>{' '}&nbsp; &nbsp; </>
                                  )}
                                </Grid>


                                {loginState ? (
                                  <React.Fragment>
                                    <Grid container spacing={2}>
                                      <Grid item xs={6}>
                                        <Button
                                          color="black"
                                          fullWidth
                                          type="submit"
                                          variant="outlined"
                                          onClick={() => setLoginState(false)}
                                          style={{ textTransform: 'none' }}
                                        >
                                          {t("label.back")}
                                        </Button>
                                      </Grid>
                                      <Grid item xs={6}>
                                        <Button
                                          color="primary"
                                          disabled={isSubmitting}
                                          fullWidth
                                          type="submit"
                                          variant="contained"
                                          style={{ textTransform: 'none' }}
                                        >
                                          {t("login.label.signin")}
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </React.Fragment>
                                ) : (
                                  <Button
                                    color="primary"
                                    disabled={isSubmitting}
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    style={{ textTransform: 'none' }}
                                  >
                                    {t("label.next")}
                                  </Button>
                                )}
                              </form>
                            )}
                          </Formik>
                        ) : (
                          <React.Fragment>
                            <Box sx={{ mb: 3 }}>
                              <Typography
                                gutterBottom
                                style={{ color: "black", textTransform: 'none' }}
                                fontSize={16}
                                lineHeight="17.6px"
                              >
                                {t("login.label.signinDesc")}
                              </Typography>
                            </Box>
                            <Button
                              color="primary"
                              fullWidth
                              type="submit"
                              variant="contained"
                              onClick={handleSsoLogin}
                              style={{ textTransform: 'none' }}
                            >
                              {/* {t("label.next")} */}
                              Login
                            </Button>
                          </React.Fragment>
                        )}
                        {loginState ? null : (
                          <Box>
                            <Typography
                              component="h5"
                              color="#A0A0A0"
                              fontSize="14px"
                              lineHeight="21px"
                              fontWeight={300}
                              textAlign="center"
                              pt="54px"
                              dangerouslySetInnerHTML={{
                                __html:
                                  t("login.label.contactHR"),
                              }}
                            ></Typography>
                          </Box>
                        )}

                      </>

                    </Paper>
                  }

                </Grid>
              )}
              <Grid container item sx={{}}></Grid>
            </Grid>
          </Grid>
        </Grid>

        {/*footer*/}
        <Grid
          container
          item
          sx={{
            bottom: 0,
          }}
        >
          <Toolbar
            color="primary"
            sx={{ "align-items": "end", "padding-left": "5px" }}
            style={styles.toolBar}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 0 }}
              p={4}
              pb={2}
              style={styles.childToolBar}
            >
              Copyright 2021 I AM Consulting Co., Ltd. All Rights Reserved
            </Typography>
          </Toolbar>
        </Grid>
        <ConfirmDialog
          open={isSsoDialogOpen}
          warning={true}
          doConfirm={() => handleConfirmOpenSso()}
          setValue={() => handleSsoDialog(false)}
          title="คำเตือน"
          text="คุณยืนยันที่จะออกจากเว็บไซต์เพื่อไปยังหน้า ลงชื่อเข้าใช้ หรือไม่ ?"
        />
      </Grid>
      {/*</Box>*/}
    </>
  );
};
export default LoginView;
